import React from 'react';
import { stats } from '../../data/content';
export function StatsBar() {
  return <section aria-label="Results in numbers" className="w-full bg-ink px-4 py-10 sm:px-6 sm:py-12" data-id="element-270" data-mp="1j8ma64pvky1q">
      <div className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-x-4 gap-y-8 sm:gap-x-6 lg:grid-cols-4" data-id="element-271" data-mp="1o7p4ov88blvg">
        {stats.map(stat => <div key={stat.label} className="flex flex-col items-center text-center" data-id="element-272" data-mp="1t00662imbfq4">
            <span className="font-display text-3xl font-bold leading-none text-white sm:text-4xl" data-id="element-273" data-mp="1x2mz66r0z6ow">
              {stat.value}
            </span>
            <span className="mt-2.5 text-[10px] font-bold uppercase leading-snug tracking-[0.12em] text-white/55 sm:text-[11px]" data-id="element-274" data-mp="26zhyusz1bd4r">
              {stat.label}
            </span>
          </div>)}
      </div>
    </section>;
}